const patientComments = [
    {
        "name": "Sarah Johnson",
        "location": "New York, NY",
        "rating": 5,
        "feedback": "I had a wonderful experience with Dr. Smith. He was attentive, explained everything clearly, and the treatment was effective. I highly recommend him.",
        "image": "https://images.unsplash.com/photo-1633332755192-727a05c4013d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8dXNlcnxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60"
    },
    {
        "name": "Michael Brown",
        "location": "Los Angeles, CA",
        "rating": 4,
        "feedback": "Dr. White provided excellent care for my child. She was patient and made my child feel comfortable during the visit. The clinic staff were also friendly.",
        "image": "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8dXNlcnxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60"
    },
    {
        "name": "Emily White",
        "location": "Chicago, IL",
        "rating": 5,
        "feedback": "I'm very satisfied with the services at this hospital. Dr. Lee is a skilled ophthalmologist, and the entire team was professional and caring. Thank you!",
        "image": "https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8dXNlcnxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60"
    },
    {
        "name": "David Lee",
        "location": "Houston, TX",
        "rating": 5,
        "feedback": "My experience with Dr. Johnson was outstanding. She took the time to listen to my concerns and provided clear explanations. I felt well taken care of.",
        "image": "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTh8fHVzZXJ8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=500&q=60"
    },
    {
        "name": "Linda Davis",
        "location": "Miami, FL",
        "rating": 4,
        "feedback": "Dr. Brown has been our family's doctor for years. His expertise and friendly demeanor make every visit pleasant. We trust him completely.",
        "image": "https://images.unsplash.com/photo-1619895862022-09114b41f16f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjB8fHVzZXJ8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=500&q=60"
    }
]

export default patientComments;
